import script from "./LeaderProjectFormButtons.vue?vue&type=script&setup=true&lang=js"
export * from "./LeaderProjectFormButtons.vue?vue&type=script&setup=true&lang=js"

import "./LeaderProjectFormButtons.vue?vue&type=style&index=0&id=110be0ff&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-110be0ff"]])

export default __exports__